'use client';

import { useEffect } from 'react';
import { usePathname } from '@/i18n/routing';

//* Styles
import PageStyle from './style';

//* Helpers
import { config } from '@/helpers';

const Page = ({ children, isDistance = true }) => {
	const pathname = usePathname();
	useEffect(() => {
		window.history.scrollRestoration = 'manual';

		window.onbeforeunload = function () {
			window.history.scrollRestoration = 'manual';
		};

		return () => {
			window.onbeforeunload = null;
		};
	}, []);

	return <PageStyle className={`main-container ${isDistance && !pathname.includes(config.routes.service.path) && !(pathname == config.routes.home.path) ? 'is-distance' : ''}`}>{children || null}</PageStyle>;
};

Page.displayName = 'Page';

export default Page;
